import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';

// Create Shift Schedule
export const createShiftSchedule = createAsyncThunk(
  'shiftSchedule/create',
  async (shiftData: Omit<any, 'ScheduleID'>, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.post('/shift-schedule', shiftData);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to create shift schedule');
    }
  }
);

// Update Shift Schedule
export const updateShiftSchedule = createAsyncThunk(
  'shiftSchedule/update',
  async ({ scheduleId, data }: { scheduleId: number; data: Partial<any> }, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.put(`/shift-schedule/${scheduleId}`, data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to update shift schedule');
    }
  }
);    

// Delete Shift Schedule
export const deleteShiftSchedule = createAsyncThunk(
  'shiftSchedule/delete',
  async (scheduleId: number, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.delete(`/shift-schedule/${scheduleId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to delete shift schedule');
    }
  }
);

// Fetch Shift Schedule by ID
export const fetchShiftScheduleById = createAsyncThunk(
  'shiftSchedule/fetchById',
  async (scheduleId: number, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get(`/shift-schedule/${scheduleId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch shift schedule');
    }
  }
);

// Fetch All Shift Schedules
export const fetchAllShiftSchedules = createAsyncThunk(
  'shiftSchedule/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get('/shift-schedule');
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch all shift schedules');
    }
  }
);
